'use client'
import React, { useState, useEffect } from 'react'
import { getEnvironmentConfig, type EnvironmentConfig } from '@/utilities/getEnvironment'

export const EnvironmentLogo: React.FC = () => {
  const [envConfig, setEnvConfig] = useState<EnvironmentConfig | null>(null)

  useEffect(() => {
    // Only run on client after mount
    setEnvConfig(getEnvironmentConfig())
  }, [])

  const logoColor = envConfig?.showBadge ? envConfig.color : '#fff'

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      <span
        style={{
          fontSize: '24px',
          fontWeight: 'bold',
          color: logoColor,
          letterSpacing: '-0.5px',
        }}
      >
        RS-42
      </span>
      {envConfig?.showBadge && (
        <span
          style={{
            fontSize: '10px',
            fontWeight: 'bold',
            padding: '3px 8px',
            borderRadius: '12px',
            backgroundColor: envConfig.bgColor,
            color: envConfig.color,
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
          }}
        >
          {envConfig.label}
        </span>
      )}
    </div>
  )
}

export default EnvironmentLogo
